import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { CommonData } from '../../../providers/common-data';
import { UserData } from '../../../providers/user-data';
import moment from 'moment';
import { ToastController } from 'ionic-angular';
import { Http } from '@angular/http';
import { MandantenData } from '../../../providers/mandanten-data';

/**
 * Generated class for the AdminPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbadmin',
  templateUrl: 'pbadmin.html',
})
export class PbAdminPage {
  dBegin;
  dEnd;
  mandat_id;
  previewSuccess: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams
    , public common: CommonData
    , public userData: UserData
    , public mandData: MandantenData
    , public toastCtrl: ToastController
    , public http: Http
    , public loadingCtrl: LoadingController
    ) {

      let d = moment();
      //d.add(1, "day");
      //d.set({hour:10,minute:0,second:0,millisecond:0})
      //this.dBegin = d.toISOString();   
      this.dBegin = d.subtract(2,'months').endOf('month').add(1,'days').hours(5).minutes(0).seconds(0).milliseconds(0).toISOString(); 
      //console.log(this.dBegin);
      let d2 = moment();
      d2.set({hour:23,minute:59,second:59,millisecond:0})
      this.dEnd = d2.subtract(1,'months').endOf('month').hours(21).minutes(0).seconds(0).milliseconds(0).toISOString(); 
  }

  ionViewDidLoad() {

  }

  pbGutschrift(update_verrechnet:boolean){
    //report.php, mandat_id
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,mandid: this.mandat_id
        ,token: this.userData.jwt
        ,update_verrechnet: update_verrechnet
      });

      let loading = this.loadingCtrl.create({
        content: 'Dokument wird vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout2 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Abrechnung fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'parkbewilligung/gutschrift.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);
          let data = response.json();
          
          if(data.success === true){
            
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);          
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });    
  }

  pbRechnung(update_verrechnet:boolean){
    //report.php, mandat_id
    return new Promise(resolve => {
      var data = JSON.stringify({
        von: this.dBegin
        ,bis: this.dEnd
        ,mandid: this.mandat_id
        ,token: this.userData.jwt
        ,update_verrechnet: update_verrechnet
      });

      let loading = this.loadingCtrl.create({
        content: 'Dokument wird vorbereitet, bitte warten...'
      });
      loading.present();        
      //-- Timeout falls Promise nie auflöst -----
      let loadingTimeout2 = setTimeout(() => {
        loading.dismiss();
        let toast = this.toastCtrl.create({
          message: "Timeout, Abrechnung fehlgeschlagen",
          position: 'top',
          cssClass: 'toast-error',
          duration: 3000
        });
        toast.present();             
      }, 30000);


      this.http.post(this.common.ubsurl+'parkbewilligung/rechnung.php',data)
        .subscribe(response => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);
          let data = response.json();
          
          if(data.success === true){
            this.previewSuccess = !this.previewSuccess;
            let toast = this.toastCtrl.create({
              message: data.message,
              position: 'top',
              duration: 3000
            });
            toast.present();              
          }
          else{
            
            let toast = this.toastCtrl.create({
              message: 'Fehler beim Erzeugen',
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            toast.present();     
                  
            //console.log("fehler");
          }

        resolve([response]);          
        }, error => {
          loading.dismiss();
          clearTimeout(loadingTimeout2);          
          let toast = this.toastCtrl.create({
            message: 'Fehler beim Erzeugen',
            position: 'top',
            cssClass: 'toast-error',
            duration: 5000
          });
          toast.present();    
      });
    });    
  }
  

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbadmin/pbadmin.ts